/* eslint-disable react/jsx-indent */
/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import SingleParentInformation from './SingleParentInformation';
import CmsContext from 'context/CmsContext';
import * as action from '../action';
import * as c from '../constant';
import SingleParentModal from '../modals/SingleParentModal';
import { getInitials } from 'modules/BPLS/applications/helper';

function SingleParentContent({
  match,
  isLoading,
  permissions,

  showSingleParent,
  clearSingleParent,
  singleParentInfo,

  // approveTransaction,
  // rejectTransaction,

  // transactionInfo,
  onApprove,
  onReject,
  deactivateCitizen
}) {
  const setModal = useContext(ModalContext);
  const selectedSingleParent = match.params.id;

  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')
  // const [formData, setFormData] = useState({})

  // const verifyTransaction = status => {
  //   return ['AMOUNT'].includes(
  //     status
  //   );
  // };

  // const viewApproveReject = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <VerifyReceipt
  //         // onApprove={onApprove}
  //         // onReject={onReject}
  //         singleParentInfo={singleParentInfo}
  //         id={selectedSingleParent}
  //       />
  //     ),
  //     title: `Approve / Reject`,
  //     modalSize: 'modal-md',
  //   });
  // };

  // const handleOnCHange = e => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // }

  // const handleApprove = (e) => {
  //   e.preventDefault();

  //   ConfirmAlertWithAmount(
  //     'Are you sure you want to approve this transaction?',
  //     (remarks, amount) => {
  //       approveTransaction(
  //         selectedSingleParent,
  //         {
  //           remarks,
  //           amount,
  //           module_type: 'SINGLE PARENT',
  //         },
  //         () => {
  //           showTransaction(selectedSingleParent); 
  //         }
  //       );
  //     },
  //     () => {
  //       FormData
  //     },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  // const handleReject = (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to Reject this application',
  //     (remarks) => {
  //       rejectTransaction(
  //         selectedSingleParent,
  //         {
  //           remarks,
  //           status: 'REJECTED',
  //           module_type: 'SINGLE PARENT',
  //         },
  //         () => {
  //           showTransaction(selectedSingleParent);
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  const updateData = () => {
    showSingleParent(selectedSingleParent), { type: 'SOLO PARENT' };
  };

  useEffect(() => {
    if (!_.isEmpty(selectedSingleParent)) {
      updateData();
    }
    return () => {
      clearSingleParent();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedSingleParent)) {
      updateData();
    }
  }, [selectedSingleParent]);

  const handleEditModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <SingleParentModal
          actionType="EDIT"
          dataInfo={data.attributes}
          id={data.id}
        />
      ),
      title: 'Edit Citizen',
      modalSize: 'modal-lg',
    });
  };

  const handleDeactivateModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      <div>
        Are you sure, you want to{' '}
        {_.get(data, 'attributes.is_active') ? 'Deactivate' : 'Activate'} this citizen?
      </div>,
      () => {
        deactivateCitizen(
          selectedSingleParent,
          { type: 'SOLO PARENT' },
          () => {
            updateData(selectedSingleParent);
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  // format displayed name: Last, First, Middle
  const firstName = _.get(singleParentInfo, 'attributes.first_name', " ") || ""
  const lastName = _.get(singleParentInfo, 'attributes.last_name', "") || ""
  const middleName = _.get(singleParentInfo, 'attributes.middle_name', " ") || ""
  const extName = _.get(singleParentInfo, 'attributes.extension_name', " ") || ""

  const isActive = _.get(singleParentInfo, 'attributes.is_active');

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        {/* profile */}
        <div className="px-4 d-flex justify-content-between align-items-center" style={{ fontSize: '24px' }}>
          <div className="p-0 d-flex flex-nowrap w-100">
            <div className="d-flex round-image justify-content-center">
              <h3 className="d-flex align-items-center initials mb-0">
                {_.get(singleParentInfo, 'attributes.photo') !==
                  '-/format/jpeg/' ? (
                  <img
                    alt="Client Profile"
                    src={_.get(singleParentInfo, 'attributes.photo')}
                  />
                ) : (
                  getInitials(
                    `${_.get(singleParentInfo, 'attributes.first_name')} ${_.get(
                      singleParentInfo,
                      'attributes.middle_name'
                    )} ${_.get(singleParentInfo, 'attributes.last_name')}`
                  )
                )}
              </h3>
            </div>
            <div className="d-flex flex-column ml-4 justify-content-center align-items-start">
              <h1 className="transaction-company m-0">
                {lastName && firstName ? `${lastName}, ` : `${lastName} `}
                {firstName && middleName ? `${firstName} ` : `${firstName} `}
                {middleName && extName ? `${middleName} ` : `${middleName} `}
                {extName}
              </h1>
              <div className='label-title mt-1'>{`${_.get(singleParentInfo, 'attributes.mobile_number') || ''}`}</div>
            </div>
          </div>
          <div className='py-4'>
            {(isActive && Acl(permissions, ['SOCIAL AMELIORATION SINGLE PARENT DEACTIVATE']) ||
              !isActive && Acl(permissions, ['SOCIAL AMELIORATION SINGLE PARENT ACTIVATE'])) && (
                <button
                  type="button"
                  onClick={handleDeactivateModal(singleParentInfo)}
                  className={`btn ${_.get(singleParentInfo, 'attributes.is_active')
                      ? 'btn-danger'
                      : 'btn-primary cms-bg-color-primary cms-outline-primary '
                    } font-weight-bold px-4 ml-2`}
                  style={{ width: '164px', height: "32px" }}
                >
                  {isActive
                    ? 'Deactivate'
                    : 'Activate'}
                </button>
              )}
          </div>
          {/* Edit Citizen */}
          <div className="py-4">
            {Acl(permissions, ['SOCIAL AMELIORATION SINGLE PARENT EDIT']) && (
              <button
                type="button"
                onClick={handleEditModal(singleParentInfo)}
                className="btn btn-success font-weight-bold px-4 ml-2"
                style={{ width: '164px', height: "32px" }}
              >
                <i className="fas fa-plus" /> &nbsp;&nbsp;
                Edit Information
              </button>
            )}
          </div>
        </div>
        <div className="mb-4">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  {/* Action buttons on top */}
                  <div className={`d-flex ml-auto justify-content-end mb-3 ${_.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan'}` && 'd-none'}>
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      <div className="d-flex flex-row justify-content-center align-items-center mr-4" style={{ height: '40px' }}>
                        <label className="alert" style={{ marginBottom: '0' }}>
                          <b>Amount: </b>
                        </label>
                        <div className="alert alert-info" style={{ marginBottom: '0' }}>
                          {_.get(singleParentInfo, 'attributes.amount') || '- -'}
                        </div>
                      </div>
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      <button
                        type="button"
                        onClick={onApprove(singleParentInfo)}
                        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-2"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Approve <i className="fas fa-check ml-1" />
                          </>
                        )}
                      </button>
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      // reject
                      <button
                        type="button"
                        onClick={onReject(singleParentInfo)}
                        className="gen-btn btn btn-danger font-weight-bold"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Reject <i className="fas fa-times ml-1" />
                          </>
                        )}
                      </button>
                    )}
                  </div>
                  <hr />
                  <SingleParentInformation
                    singleParentInfo={singleParentInfo}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

SingleParentContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,

  // transactionInfo: PropTypes.instanceOf(Object).isRequired,

  clearSingleParent: PropTypes.instanceOf(Function).isRequired,
  singleParentInfo: PropTypes.instanceOf(Object).isRequired,
  showSingleParent: PropTypes.instanceOf(Function).isRequired,

  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  // rejectTransaction: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onReject: PropTypes.instanceOf(Function).isRequired,
  deactivateCitizen: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),

  // transactionInfo: _.get(api, `${c.SHOW_INCIDENT}.item`) || {},

  singleParentInfo: _.get(api, `${c.SHOW_SINGLE_PARENT}.item`) || {},
  isLoading: api.loading.indexOf(c.SHOW_SINGLE_PARENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(SingleParentContent);
